import { render, staticRenderFns } from "./MoneyField.vue?vue&type=template&id=65e824c7&scoped=true&"
import script from "./MoneyField.vue?vue&type=script&lang=js&"
export * from "./MoneyField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e824c7",
  null
  
)

export default component.exports